import { useEffect, useRef } from 'react';

export function useLastDefinedValue<T>(value: T | undefined) {
    const lastDefined = useRef(value);

    useEffect(() => {
        if (value !== undefined) {
            lastDefined.current = value;
        }
    }, [value]);

    return value ?? lastDefined.current;
}
